export async function retry<T>(attempts: number, cb: () => Promise<T>) {
    let error: Error

    for (let i = 0; i < attempts; i++) {
        try {
            return await cb()
        } catch (err) {
            error = err
            await wait(500)
        }
    }

    throw error
}

export async function retrySafe(attempts: number, cb: () => Promise<boolean>): Promise<boolean> {
    for (let i = 0; i < attempts; i++) {
        const result = await cb()
        if (result) {
            return true
        }
        await wait(500)
    }
    return false
}

// Based on https://www.codewithyou.com/blog/how-to-implement-retry-with-exponential-backoff-in-nodejs
export async function retryWithBackoff<T>(cb: () => Promise<T>, attempts = 5, baseDelayMs = 100) {
    let attempt = 1

    const execute: () => Promise<T> = async () => {
        try {
            return await cb()
        } catch (error) {
            if (attempt >= attempts) {
                throw error
            }

            const delayMs = baseDelayMs * 2 ** attempt

            // eslint-disable-next-line no-console
            console.error(`retryWithBackoff() - Error: '${error.message}'. Will retry after ${delayMs}ms`)

            await wait(delayMs)

            attempt++
            return execute()
        }
    }

    return execute()
}

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
